export const THEME_COLORS = {};
